import { useApp } from '@/App';
import { useModals } from '@/components/modals/ModalProvider';
import FleetTitle from '@/libs/antd/components/Title';
import { FleetGetListParams } from '@/libs/fleet-api/fetcher';
import {
	useMonitoringCovenantSearchCustomer,
	useMonitoringCovenantSearchOptions,
} from '@/libs/fleet-api/services/monitoring';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Button, Input, Select, Space, Table } from 'antd';
import { FC, Fragment, useState } from 'react';

const MonitoringCovenantListPage: FC = () => {
	const { navigate } = useApp();
	const { openCustomerGroupDetail, openCustomerDetail } = useModals();

	const [param, setParam] = useState<FleetGetListParams>({
		pagination: {
			pageNumber: 1,
			pageSize: 10,
		},
		search: {
			by: '',
			value: '',
		},
	});

	const {
		data: covenantOptions,
		isLoading: covenantLoading,
		error: covenantError,
	} = useMonitoringCovenantSearchOptions();

	const searchByOptions = covenantOptions?.data.searchByOptions || [];

	const [searchBy, setSearchBy] = useState<string>(
		searchByOptions[0]?.id.toString() || '',
	);
	const [searchValue, setSearchValue] = useState('');

	const searchCustomerQuery = useMonitoringCovenantSearchCustomer(param);

	const handleSearch = () => {
		setParam({
			...param,
			search: {
				by: searchBy,
				value: searchValue,
			},
			pagination: {
				...param.pagination,
				pageNumber: 1, // Reset to first page when searching
			},
		});
	};

	const handleTableChange = (pagination: {
		current?: number;
		pageSize?: number;
	}) => {
		if (pagination) {
			setParam({
				...param,
				pagination: {
					pageNumber: pagination.current || 1,
					pageSize: pagination.pageSize || 10,
				},
			});
		}
	};

	return (
		<Fragment>
			<Space
				direction="vertical"
				style={{ display: 'flex' }}
				size={'large'}
			>
				<FleetTitle style={{ marginBottom: 20 }}>
					Monitoring Covenant
				</FleetTitle>

				<div style={{ display: 'flex', gap: 8, width: '100%' }}>
					<span
						style={{
							whiteSpace: 'nowrap',
							display: 'flex',
							alignItems: 'center',
							fontWeight: 700,
							marginRight: 100,
							marginLeft: 20,
						}}
					>
						Kata Kunci
					</span>
					<Select
						loading={covenantLoading}
						disabled={covenantLoading || !!covenantError}
						style={{ minWidth: 200 }}
						value={searchBy}
						onChange={(value) => {
							setSearchBy(value);
							// Reset search value when changing type to avoid mismatched data
							setSearchValue('');
						}}
						options={searchByOptions.map((opt) => ({
							label: opt.value,
							value: opt.id,
						}))}
						placeholder="Cari berdasarkan"
					/>
					<Input
						placeholder="Masukkan kata kunci..."
						value={searchValue}
						onChange={(e) => setSearchValue(e.target.value)}
						onPressEnter={handleSearch}
						allowClear
						// onClear={() => {
						// 	setSearchValue('');
						// 	setSearchBy('');
						// 	handleSearch();
						// }}
					/>

					<Button
						type="primary"
						onClick={handleSearch}
						style={{ width: 300, fontWeight: 700 }}
						loading={searchCustomerQuery.isLoading}
						disabled={!searchBy || !searchValue}
					>
						SEARCH
					</Button>
				</div>
				{covenantError && (
					<div style={{ color: 'red' }}>Gagal memuat opsi pencarian.</div>
				)}
			</Space>

			{/* Table Section */}
			<div style={{ marginTop: 20 }}>
				<Table
					style={{ marginBlock: 20 }}
					bordered
					scroll={{ x: 'max-content' }}
					loading={searchCustomerQuery.isLoading}
					dataSource={searchCustomerQuery.data?.items?.map((record, key) => ({
						...record,
						key,
					}))}
					pagination={{
						current: param.pagination.pageNumber,
						total: searchCustomerQuery.data?.totalCount || 0,
						pageSize: param.pagination.pageSize,
						onChange: (page, pageSize) => {
							setParam({
								...param,
								pagination: {
									pageNumber: page,
									pageSize: pageSize,
								},
							});
						},
						// showSizeChanger: false,
						// showQuickJumper: false,
					}}
					onChange={handleTableChange}
					columns={[
						{
							title: 'No',
							align: 'center',
							fixed: 'left',
							width: 60,
							render: (_, __, index) =>
								(param.pagination.pageNumber - 1) * param.pagination.pageSize +
								index +
								1,
						},
						{
							title: 'Customer ID',
							render: (record) => record.customerId ?? '-',
						},
						{
							title: 'Nama Customer',
							render: (record) => {
								return (
									<a
										href="#"
										onClick={(e) => {
											e.preventDefault();
											openCustomerDetail(record.customerId);
										}}
									>
										{record.customerName}
									</a>
								);
							},
						},
						{
							title: 'Group BMPP',
							render: (_, record) => {
								if (record.bmppGroupId) {
									return (
										<a
											href="#"
											onClick={(e) => {
												e.preventDefault();
												openCustomerGroupDetail(record.bmppGroupId);
											}}
										>
											{record.bmppGroupName ?? '-'}
										</a>
									);
								}
								return <>{record.bmppGroupId ?? '-'}</>;
							},
						},
						{
							title: 'Action',
							fixed: 'right',
							align: 'center',
							width: 80,
							render: (_, record) => (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										navigate('MonitoringCovenantCustomerPage', {
											customerId: record.customerId,
										});
									}}
								>
									<ArrowRightOutlined />
								</a>
							),
						},
					]}
				/>
			</div>
		</Fragment>
	);
};

export default MonitoringCovenantListPage;
